import { CheckTypeInfo } from "../api/Blueprints";
import { XPage } from "../api/GenericModels";
import { buildMockPromise } from "../api/helpers";

const STANDARD_BEHAVIORS = [
  "CANNABIS",
  "COMMUNITY",
  "CRIMINAL",
  "HARASSMENT",
  "INTOLERANCE",
  "OTHER DRUGS",
  "SEX",
  "THREAT",
  "VIOLENCE",
];

const ALL_SOURCES = [
  "Bluesky",
  "Facebook",
  "Instagram",
  "LinkedIn",
  "Other",
  "PDFGenerator",
  "TikTok",
  "Twitter",
  "Web Content",
  "YouTube",
];

const SOCIAL_SOURCES = [
  "Bluesky",
  "Facebook",
  "Instagram",
  "LinkedIn",
  "TikTok",
  "Twitter",
];

const NO_WEB_SOURCES = [
  "Bluesky",
  "Facebook",
  "Instagram",
  "LinkedIn",
  "Other",
  "PDFGenerator",
  "TikTok",
  "Twitter",
  "YouTube",
];

const checkTypesMockData: CheckTypeInfo[] = [
  {
    blueprint_uuid: "c6b8d85b-e76d-4227-8ac0-409dad6233bc",
    name: "Essential Green - All Sources - Misconduct - 3 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Green",
    sources: ALL_SOURCES.filter((s) => s !== "YouTube"),
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 12,
    turn_around: "HOURS",
    lookback: 3,
    description: "Standard essential misconduct package with hour-based SLA.",
  },
  {
    blueprint_uuid: "e7b64faf-047d-4977-a407-2a1f6011d1b0",
    name: "Essential Orange - All Sources - Misconduct - 3 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Orange",
    sources: ALL_SOURCES.filter((s) => s !== "YouTube"),
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 12,
    turn_around: "HOURS",
    lookback: 3,
  },
  {
    blueprint_uuid: "2f56137b-8a5e-498f-bc84-2b00ef7c95d8",
    name: "360 Standard - News & Legal - 4 Months",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Blue",
    item_types: ["news", "legal_cases", "summaries"],
    sources: SOCIAL_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 71,
    turn_around: "HOURS",
    lookback: 4,
  },
  {
    blueprint_uuid: "9e7ab9f1-f9b6-4863-88d6-4d37914159c6",
    name: "Essential Blue - PDF & Web - Misconduct - 4 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Blue",
    sources: ["Bluesky", "PDFGenerator", "Web Content"],
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 71,
    turn_around: "HOURS",
    lookback: 4,
  },
  {
    blueprint_uuid: "3cd8c9b0-3055-4f87-8a3a-1d14209d4336",
    name: "Longview - 360 Due Diligence - 10 Years",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Pink",
    item_types: ["news", "fama_reports", "diligence"],
    sources: ALL_SOURCES.filter((s) => s !== "YouTube"),
    behaviors: [
      "CANNABIS",
      "COMMUNITY",
      "HARASSMENT",
      "INTOLERANCE",
      "SEX",
      "THREAT",
    ],
    sla_hours: 0,
    turn_around: "BUSINESS_DAYS",
    lookback: 120,
  },
  {
    blueprint_uuid: "3f2748d3-2003-4578-b5ad-31b87a766c1b",
    name: "1-Year All Sources - Misconduct",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Default",
    sources: ALL_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "BUSINESS_DAYS",
    lookback: 12,
  },
  {
    blueprint_uuid: "67b77c23-8f60-4d23-a60f-d104622758a4",
    name: "All Sources - No Web - 3 Years",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Green",
    sources: NO_WEB_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "BUSINESS_DAYS",
    lookback: 36,
  },
  {
    blueprint_uuid: "9580e8d5-2fae-4162-abcf-64f6d251b4cf",
    name: "360 Hour SLA - Legal & Summaries - 1 Month",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Blue",
    item_types: ["legal_cases", "summaries", "fama_reports"],
    sources: ALL_SOURCES.filter((s) => s !== "YouTube"),
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 18,
    turn_around: "HOURS",
    lookback: 1,
  },
  {
    blueprint_uuid: "0c3ba25b-5a10-4ebe-8259-26a38bd961d0",
    name: "Business Day Calc (-1 min) - Misconduct",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Default",
    sources: ["Bluesky", "PDFGenerator", "Web Content"],
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "SINGLE_BUSINESS_DAY",
    lookback: 1,
  },
  {
    blueprint_uuid: "342a70b9-5b39-4934-98ab-cdd738d3ceb5",
    name: "Normal Business Day Calc - Misconduct",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Orange",
    sources: ["Bluesky", "PDFGenerator", "Web Content"],
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "BUSINESS_DAYS",
    lookback: 1,
  },
  {
    blueprint_uuid: "a1b2c3d4-e5f6-4789-a012-345678901001",
    name: "Essential Pink - Social Sources - Misconduct - 6 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Pink",
    sources: SOCIAL_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 24,
    turn_around: "HOURS",
    lookback: 6,
  },
  {
    blueprint_uuid: "a1b2c3d4-e5f6-4789-a012-345678901002",
    name: "Executive Screening - Full Flags - 24 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Green",
    sources: ALL_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "BUSINESS_DAYS",
    lookback: 24,
  },
  {
    blueprint_uuid: "a1b2c3d4-e5f6-4789-a012-345678901003",
    name: "Retail Standard - No YouTube - 3 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Orange",
    sources: ALL_SOURCES.filter((s) => s !== "YouTube"),
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 12,
    turn_around: "HOURS",
    lookback: 3,
  },
  {
    blueprint_uuid: "a1b2c3d4-e5f6-4789-a012-345678901004",
    name: "Healthcare Compliance - Business Day - 36 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Blue",
    sources: NO_WEB_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "BUSINESS_DAYS",
    lookback: 36,
  },
  {
    blueprint_uuid: "a1b2c3d4-e5f6-4789-a012-345678901005",
    name: "Financial Services - Hour SLA - 12 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Default",
    sources: ["LinkedIn", "Twitter", "PDFGenerator", "Web Content"],
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 48,
    turn_around: "HOURS",
    lookback: 12,
  },
  {
    blueprint_uuid: "a1b2c3d4-e5f6-4789-a012-345678901006",
    name: "Quick Turn - Hour SLA - 1 Month",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Green",
    sources: SOCIAL_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 8,
    turn_around: "HOURS",
    lookback: 1,
  },
  {
    blueprint_uuid: "a1b2c3d4-e5f6-4789-a012-345678901007",
    name: "Cannabis & Community Flags Only - 3 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Green",
    sources: SOCIAL_SOURCES,
    behaviors: ["CANNABIS", "COMMUNITY"],
    sla_hours: 12,
    turn_around: "HOURS",
    lookback: 3,
  },
  {
    blueprint_uuid: "a1b2c3d4-e5f6-4789-a012-345678901008",
    name: "LinkedIn & Twitter Focus - 6 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Blue",
    sources: ["LinkedIn", "Twitter"],
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "BUSINESS_DAYS",
    lookback: 6,
  },
  {
    blueprint_uuid: "a1b2c3d4-e5f6-4789-a012-345678901009",
    name: "PDF Generator Only - 3 Months",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Default",
    sources: ["PDFGenerator"],
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "SINGLE_BUSINESS_DAY",
    lookback: 3,
  },
  {
    blueprint_uuid: "a1b2c3d4-e5f6-4789-a012-345678901010",
    name: "Extended Lookback Green - 10 Years",
    report_type: "MISCONDUCT",
    workflow_name: "Essential",
    workflow_version: 1,
    color: "Green",
    sources: ALL_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "BUSINESS_DAYS",
    lookback: 120,
  },
  {
    blueprint_uuid: "b2c3d4e5-f6a7-4890-b123-456789012011",
    name: "360 Due Diligence - All Item Types - 12 Months",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Green",
    item_types: [
      "news",
      "legal_cases",
      "summaries",
      "fama_reports",
      "diligence",
    ],
    sources: ALL_SOURCES.filter((s) => s !== "YouTube"),
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "THREE_SIXTY",
    lookback: 12,
  },
  {
    blueprint_uuid: "b2c3d4e5-f6a7-4890-b123-456789012012",
    name: "360 Executive - Summaries Only - 6 Months",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Orange",
    item_types: ["summaries"],
    sources: ["LinkedIn", "Twitter", "Web Content"],
    behaviors: ["CRIMINAL", "HARASSMENT", "INTOLERANCE", "THREAT", "VIOLENCE"],
    sla_hours: 0,
    turn_around: "THREE_SIXTY",
    lookback: 6,
  },
  {
    blueprint_uuid: "b2c3d4e5-f6a7-4890-b123-456789012013",
    name: "360 Standard SLA - Pink - 3 Months",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Pink",
    item_types: ["news", "summaries"],
    sources: SOCIAL_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "THREE_SIXTY",
    lookback: 3,
  },
  {
    blueprint_uuid: "b2c3d4e5-f6a7-4890-b123-456789012014",
    name: "360 Fama Reports Package - 24 Months",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Blue",
    item_types: ["fama_reports", "diligence"],
    sources: ALL_SOURCES.filter((s) => s !== "YouTube"),
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 24,
    turn_around: "HOURS",
    lookback: 24,
  },
  {
    blueprint_uuid: "b2c3d4e5-f6a7-4890-b123-456789012015",
    name: "360 News Monitor - 1 Month",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Default",
    item_types: ["news"],
    sources: ["Web Content", "PDFGenerator"],
    behaviors: ["CRIMINAL", "HARASSMENT", "THREAT", "VIOLENCE"],
    sla_hours: 12,
    turn_around: "HOURS",
    lookback: 1,
  },
  {
    blueprint_uuid: "b2c3d4e5-f6a7-4890-b123-456789012016",
    name: "360 Legal Cases Focus - 12 Months",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Blue",
    item_types: ["legal_cases", "summaries"],
    sources: SOCIAL_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "BUSINESS_DAYS",
    lookback: 12,
  },
  {
    blueprint_uuid: "b2c3d4e5-f6a7-4890-b123-456789012017",
    name: "360 Social Lite - 4 Months",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Orange",
    item_types: ["news", "legal_cases"],
    sources: SOCIAL_SOURCES,
    behaviors: ["CANNABIS", "COMMUNITY", "CRIMINAL", "HARASSMENT", "SEX"],
    sla_hours: 71,
    turn_around: "HOURS",
    lookback: 4,
  },
  {
    blueprint_uuid: "b2c3d4e5-f6a7-4890-b123-456789012018",
    name: "360 Comprehensive - Full Lookback - 36 Months",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Green",
    item_types: [
      "news",
      "legal_cases",
      "summaries",
      "fama_reports",
      "diligence",
    ],
    sources: ALL_SOURCES,
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "THREE_SIXTY",
    lookback: 36,
  },
  {
    blueprint_uuid: "b2c3d4e5-f6a7-4890-b123-456789012019",
    name: "360 Hour SLA - 18 Hours - 1 Month",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Pink",
    item_types: ["summaries", "fama_reports"],
    sources: ["Bluesky", "Facebook", "Instagram", "Twitter"],
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 18,
    turn_around: "HOURS",
    lookback: 1,
  },
  {
    blueprint_uuid: "b2c3d4e5-f6a7-4890-b123-456789012020",
    name: "360 Business Day - Web & PDF - 3 Months",
    report_type: "360",
    workflow_name: "Three Sixty",
    workflow_version: 3,
    color: "Default",
    item_types: ["news", "diligence"],
    sources: ["PDFGenerator", "Web Content", "LinkedIn"],
    behaviors: STANDARD_BEHAVIORS,
    sla_hours: 0,
    turn_around: "BUSINESS_DAYS",
    lookback: 3,
  },
];

/** Full catalog page (used by `useGetCheckTypes` accumulate path). */
const checkTypesMock: XPage<CheckTypeInfo> = {
  data: checkTypesMockData,
  offset: 0,
  size: checkTypesMockData.length,
  next: null,
};

/**
 * When `offset`/`size` are omitted, returns the full catalog (legacy accumulate).
 * When provided, returns a sliced `XPage` for infinite-scroll consumers.
 */
export async function getCheckTypesMock(
  offset?: number,
  size?: number
): Promise<XPage<CheckTypeInfo>> {
  if (offset === undefined || size === undefined) {
    return buildMockPromise(checkTypesMock);
  }

  const data = checkTypesMockData.slice(offset, offset + size);
  const nextOffset = offset + size;
  const next = nextOffset < checkTypesMockData.length ? nextOffset : null;

  return buildMockPromise({
    data,
    offset,
    size,
    next,
  });
}
